import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import NewsCard from "components/News/NewsCard"
import HomeSectionWrapper from "components/HomePage/components/HomeSectionWrapper"
import { AVAILABLE_ROUTES } from "containers/Layout/components/NavBar"

const HomeThirdSection = () => {
  // Grab the top 4 news posts (the newest ones)
  const data = useStaticQuery(graphql`
    query TopNewsPosts {
      allMarkdownRemark(
        filter: {fileAbsolutePath: {regex: "/news/"}}
        sort: {frontmatter: {date: DESC}}
        limit: 3
      ) {
        edges {
          node {
            frontmatter {
              title
              cover
              readingTime
              imgCredits
              featuredImage {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
              slug
              author
              date(formatString: "MMMM DD, YYYY")
            }
          }
        }
      }
    }
  `)

  const newsPosts = data?.allMarkdownRemark?.edges.map((post, key) => {
    const {
      node: {
        frontmatter: {
          slug,
          author,
          date,
          title,
          cover,
          featuredImage,
          readingTime,
          imgCredits
        },
      },
    } = post

    return (
      <NewsCard
        {...{
          grid: { xl: 4, lg: 4, md: 4, sm: 4, xs: 12 },
          slug,
          author,
          date,
          title,
          cover,
          featuredImage,
          key,
          readingTime,
          prevUrl: "/",
          imgCredits
        }}
      />
    )
  })
  return (
    <HomeSectionWrapper
      {...{
        sectionTitle: "News and Thoughts",
        sectionDescription: "News from the Mercedes-Benz Open Source Team",
        sectionButtonTitle: "Show all posts and news",
        sectionButtonLink: AVAILABLE_ROUTES.NEWS.to,
      }}
    >
      {newsPosts}
    </HomeSectionWrapper>
  )
}

export default HomeThirdSection
